import { Skeleton } from "antd";

function CardSkeleton() {
    return (
        <Skeleton
            active
            title={{ width: '60%' }}
            paragraph={{ rows: 3, width: ['90%', '80%', '70%'] }}
        />
    )
}
export default CardSkeleton